import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method getProfile
 * @method getPoint
 * @method updateProfile
 * @method updateShippingAddress
 * @method registerUser
 * @method changePassword
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    /*Get Location Near By*/
    LocationNearby: function (strBzbsToken, latCurrent, lngCurrent, device_locale, agencyID) {
        var params = {
            device_app_id: Vue.bzbsConfig.client_id,
            distance: '1000000000',
            mode: 'nearby',
            within_area: '0',
            require_campaign: '0',
        };

        if (latCurrent && lngCurrent)
            params.center = latCurrent+","+lngCurrent;

        if (device_locale)
            params.device_locale = device_locale;

        if(agencyID)
            params.agencyId = agencyID;

        var strUrl = this.config().bzbsServiceUrl + "/place";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params);
    },

}

